import React from "react";
// Layout

// Default
import { useState, ReactNode } from "react";

// Mui
import Box from "@mui/material/Box";

// Custom
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import Sidebar from "../components/sidebar/Sidebar";

// Mui
import Stack from "@mui/material/Stack";

// Utils
import { getPageTitle } from "../utils/helper";

// Types
interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#F3F6FC",
      }}
    >
      <Stack
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 950,
          backgroundColor: "#F3F6FC",
          pl: "72px",
        }}
      >
        <Header
          setSidebarOpen={setSidebarOpen}
          title={getPageTitle(window.location.pathname) || "Dashboard 360"}
        />
      </Stack>

      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          pl: "72px",
        }}
      >
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        {children}
      </Box>

      <Box
        sx={{
          mt: "auto",
        }}
      >
        <Footer />
      </Box>
    </Box>
  );
};

export default Layout;
